import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class TenantSpoofService {
  private spoofSubject = new BehaviorSubject<string | null>(null);
  spoofedTenant$ = this.spoofSubject.asObservable();

  get spoofedTenant(): string | null {
    if (environment.production) return null;
    return this.spoofSubject.value;
  }

  spoofTenant(name: string): void {
    if (environment.production) return;
    this.spoofSubject.next(name);
  }

  clearSpoof(): void {
    this.spoofSubject.next(null);
  }
}
